import { atom } from "jotai";
import type { Theme } from "@/types/Theme";

export const themeAtom = atom<Partial<Theme>>("default");
